// ─── Sentry must be imported BEFORE everything else ─────────────────────────
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_ENVIRONMENT || "development",
  // 10 % sampling in prod, 100 % elsewhere
  tracesSampleRate: process.env.REACT_APP_ENVIRONMENT === "production" ? 0.1 : 1.0,
  // Replay 1 % of sessions; 100 % when an error occurs
  replaysSessionSampleRate: 0.01,
  replaysOnErrorSampleRate: 1.0,
  integrations: [
    Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
  ],
  // Don't report browser extension noise
  ignoreErrors: [
    "ResizeObserver loop limit exceeded",
    "Non-Error promise rejection captured",
    "chrome-extension://",
    "moz-extension://",
  ],
});

// Restore user context for already-logged-in sessions
try {
  const slug = localStorage.getItem('organizationSlug') || localStorage.getItem('orgSlug');
  const orgId = localStorage.getItem('organizationId');
  if (slug) {
    Sentry.setUser({ username: slug, id: orgId || undefined });
    Sentry.setTag('org_slug', slug);
  }
} catch (_) {}
// ─────────────────────────────────────────────────────────────────────────────
// ─────────────────────────────────────────────────────────────────────────────

import React from "react";
import ReactDOM from "react-dom/client";
import { SWRConfig } from "swr";
import "@/index.css";
import App from "@/App";
// Clerk disabled - using custom JWT auth instead
// import { ClerkProvider } from '@clerk/clerk-react';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

// Clerk disabled - using custom JWT auth
// const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

// Initialize PostHog
posthog.init(
  process.env.REACT_APP_POSTHOG_KEY,
  {
    api_host: process.env.REACT_APP_POSTHOG_HOST,
    person_profiles: 'identified_only',
    capture_pageview: false, // We'll handle pageviews manually for SPA
  }
);

// Register Service Worker for PWA functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        
        // Listen for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              }
            });
          }
        });
      })
      .catch((error) => {
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <SWRConfig
        value={{
          revalidateOnFocus: true,
          revalidateOnReconnect: true,
          focusThrottleInterval: 10000,
          dedupingInterval: 5000,
          errorRetryCount: 2,
        }}
      >
        <App />
      </SWRConfig>
    </PostHogProvider>
  </React.StrictMode>,
);
